export enum ActionType {
  PTP = 'PTP',
  CALL = 'CALL',
  OTHERS = 'OTHERS',
  BP = 'BP',
}
